import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { CollectionProgram } from '../collection/collection.domain';

export type DuplicatedCollection = Pick<
  CollectionProgram,
  'id' | 'name' | 'description' | 'influencerId'
>;

const duplicateCollection = async (
  collectionId: number,
): Promise<DuplicatedCollection> => {
  const token = auth.getToken();

  const response = await axios.post(
    getCreatorApiUrl(`/program/${collectionId}/duplicate`),
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export const useDuplicateCollectionQuery = () =>
  useMutation({
    mutationFn: duplicateCollection,
  });
